import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setAbroadModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';

const AbroadModal: React.FC<IProps> = (props) => {
  const handleClose = () => {
    props.setAbroadModalVisible(false);
  };

  return (
    <>
      {props.modal.abroadModalVisible && (
        <div className="abroad-modal">
          <Modal
            visible={props.modal.abroadModalVisible}
            confirmButton={false}
            onCancel={handleClose}
          >
            <div className="abroad-modal__example-image" />
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAbroadModalVisible: (visible: boolean) => dispatch(setAbroadModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(AbroadModal);
